import { Button } from "components/DesignSystem/Button/Button";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { SmallCaret } from "components/icons/SmallCaret";
import { useAuth } from "hooks/useAuth";
import { useUserOnboardingStepper } from "hooks/useUserOnboardingStepper";
import { ChatCartPaid } from "components/icons/Chat/ChatCartPaid";

export const ViewSignUp = () => {
  const authtoken = useAuth();
  let userData = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const { currentStepNumber } = useUserOnboardingStepper();
  const user = {
    first_name: authtoken?.first_name || userData?.first_name || "",
    last_name: authtoken?.last_name || userData?.last_name || "",
    email: authtoken?.email || userData?.email || "",
  };

  return (
    <div>
      <div className="t-flex t-flex-col t-gap-1 t-mb-8">
        <div className="t-text-subtitle-lg t-text-text-100">
          Let's set up your Inkle account
        </div>
        <div className="t-flex t-gap-2">
          <div className="t-text-body-sm t-text-text-30">
            Already have an account?
          </div>
          <Button customType="link" disabled>
            <div className="t-flex t-gap-2 t-items-center">
              <span>Sign In</span>
              <SmallCaret />
            </div>
          </Button>
        </div>
      </div>
      <FormikForm initialValues={user} onSubmit={() => {}}>
        <div className="t-flex t-flex-col t-gap-5">
          <div className="t-flex t-gap-4">
            <TextInput
              name="first_name"
              label="First name"
              disabled
              rightComponent={<ChatCartPaid />}
            />
            <TextInput
              name="last_name"
              label="Last name"
              disabled
              rightComponent={<ChatCartPaid />}
            />
          </div>
          <TextInput
            name="email"
            label="Work email address"
            disabled
            rightComponent={<ChatCartPaid />}
          />
        </div>
      </FormikForm>
    </div>
  );
};
